// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectLocationPopup__map-container-d82eed {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0 16px;
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SelectLocationPopup/SelectLocationPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AACF","sourcesContent":[".map-container {\n  flex: 1;\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 0 16px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"map-container": `SelectLocationPopup__map-container-d82eed`,
	"mapContainer": `SelectLocationPopup__map-container-d82eed`
};
module.exports = ___CSS_LOADER_EXPORT___;
